module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "epub:type": "prologue",
      "id": "prologue",
      "role": "doc-prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("TEN YEARS AGO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-t"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("ick tock. Time was up. He couldn’t move. Couldn’t leave her. He belonged with her, and it crushed him that he had to go. The heat from her body long gone, his happiness had generated enough warmth to envelop them both. He rested his head tenderly against her chest and caressed the hard scars running down the inside of her forearm.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her closeness brought to the surface the good childhood memories he hadn’t thought of in years. Like the times she came home after a modelling job. She would be at her happiest, and she’d scoop him up and hug him tight. Her little prince.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Eyes wet, he blinked furiously. He mustn’t spoil these last moments.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thank you,’ he whispered. His gratitude was so profound, her long estrangement from him was forgiven. All her trespasses no longer mattered.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He pushed up from the bed, cursing when the old mattress springs dug into his palms.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m sorry I’ve got to go.’ His voice was hoarse from talking. While brushing the tangles from her hair, he’d chatted about everything she had missed. He wasn’t one for lengthy speeches and afterwards his soul felt cleansed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("God, the irony. It was probably a long time since someone had felt cleansed in her flat.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He bent over and kissed her forehead. Alongside the fruity scent of the cheap shower gel he’d used to wash her, was the cloying smell of death.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She was at peace. It was his gift to her: release from the shitty existence she had chosen instead of him. He envied her. His nightmares would never be free of the addictive hunger.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Over the last few hours, the knot in his stomach had loosened. The connection they’d shared – her recognition, then acceptance – was an intimacy he hadn’t experienced since his previous life. But how long before loneliness fuelled more urges?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In his strange confession, he’d spoken about the person whose existence he had denied. His guardian angel. If he could find acceptance here, then maybe his happiness depended on finding her. A familiar spark glimmered deep inside. He beat it down. No. Not yet. He wasn’t ready.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Picking a route through the beer cans and drug paraphernalia, he headed towards the door. An empty syringe crunched under foot; his shoes sticking on the ingrained layer of grime and neglect beneath all the detritus. He looked into her sightless eyes one final time before he stepped over the threshold. Other sounds became real again: shouts from an upstairs flat and the undulating hum of the last fragments of evening traffic intruded into the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Six hours had passed since he’d followed his mum, put his hands around her neck and ended her life. No one would understand why he’d done that, but it still disappointed him the rest of the world hadn’t taken the trouble to notice.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c1691e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 72
// module chunks = 0